import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

const StageCategoryTableColumns = ({columns, data, onClick}) => (<>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.first_stage_category?.width}>
        {data.stage_category?.parent?.name}
    </Grid.Column>
    <Grid.Column data-id={data.id} onClick={onClick} width={columns?.second_stage_category?.width}>
        {data.stage_category?.name}
    </Grid.Column>
</>);

StageCategoryTableColumns.propTypes = {
    columns: PropTypes.object.isRequired,
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        stage_category: PropTypes.shape({
            parent: PropTypes.shape({name: PropTypes.string}),
            name: PropTypes.string,
        }),
    }).isRequired,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
};

export default StageCategoryTableColumns;

